import { useCallback } from 'react';

import * as Types from './types';
import { TServerSendRequest } from '../../types';
import { useGenericSend } from '../useGenericSend';

export const useGetPlayerReminders = () => {
    const send = useGenericSend();

    return useCallback(async (): Promise<Types.IGetPlayerRemindersResponse> => {
        const { data } = await send<TServerSendRequest, Types.IGetPlayerRemindersResponse>({
            ID: 36013,
            responses: [36014, 36015],
            description: 'Get player reminders',
            errorLevel: 1
        });

        return data;
    }, [send]);
};
